import React from 'react'
import { Loader } from 'semantic-ui-react';

import CountCardHeader from './../Drive/Cards/CountCardHeader';
import FourBlockDivision from '../Drive/Cards/FourBlockDivision'
import TwoBlockWithHeader from './../Drive/Cards/TwoBlockWithHeader'
import content from "../../../../images/svg/noti-content.svg";

class CountBlock extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    componentWillMount() {
        this.setState({ loading: true });
        setTimeout(
            function () {
                this.setState({ loading: false });
            }.bind(this), 2000
        );
    }

    render() {
        let showLoader = this.state.loading || this.props.loadingContent;
        return (
            <div>
                <div className="display-flow-root">
                    <CountCardHeader
                        name="Content"
                        type="content"
                        image={content}
                        totalCount={this.props.contentCountData.total}
                        selectedOrganisation={this.props.selectedOrganisation}
                    />
                </div>
                {showLoader ?
                    <div className="setLoader" style={{ padding: "94px 0" }}>
                        <Loader active inline />
                    </div> : ""}
                <div className="count-content">
                    <FourBlockDivision
                        type="content"
                        label1Name="In Design"
                        isLoadingData={this.props.isLoadingData}
                        label1Count={this.props.contentCountData.inDevelopment ? this.props.contentCountData.inDevelopment : 0}
                        label2Name="Approved"
                        label2Count={this.props.contentCountData.approved ? this.props.contentCountData.approved : 0}
                        label3Name="Published"
                        label3Count={this.props.contentCountData.published ? this.props.contentCountData.published : 0}
                        label4Name="Purchased"
                        label4Count={0}
                        selectedOrganisation={this.props.selectedOrganisation}
                        history={this.props.history}
                    />
                    <TwoBlockWithHeader
                        header="Review Requests"
                        type="content"
                        label1Name="Received"
                        label1Count={showLoader ? 0 : this.props.contentCountData.forReview}
                        label2Name="Sent"
                        label2Count={showLoader ? 0 : this.props.contentCountData.reviewReq}
                        user={this.props.user}
                        selectedOrganisation={this.props.selectedOrganisation}
                        history={this.props.history}
                    />
                </div>
            </div>
        )
    }
}

export default CountBlock;
